import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { axios } from "../../helpers"
import useDateConvert from "../../hooks/useDateConvert"
import { ANNOUNCEMENTDETAIL } from "../../routes/routes_name"

const useAnnouncementDetail = () => {
    const [data, setData] = useState({})
    const [dataOthers, setDataOthers] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const location = useLocation()
    const { getTimestampToDateTime } = useDateConvert()
    const navigate = useNavigate()

    useEffect(() => {
        setData(location.state)
        fetchDataOthers(location.state.id)
    }, [])

    const fetchDataOthers = async (id) => {

        setIsLoading(true)
        try {

            const response = await axios.get(`/pengumuman`)
            if (response.status === 200) {
                const newDataOthers = response.data.data.rows.filter(item => item.id !== id)
                setDataOthers(newDataOthers)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleClickOther = (d) => {
        navigate(ANNOUNCEMENTDETAIL, { state: d })
        window.location.reload()
    }

    return {
        data,
        isLoading,
        dataOthers,
        handleClickOther,
        getTimestampToDateTime,
    }
}
export default useAnnouncementDetail